export default __webpack_public_path__ + "static/media/473.6f20eebe.png";